import { useState } from "react";

import { makePostApiCall } from "../../../shared/makeApiCall";
import { BannerNotificationType } from "../../../components/SimpleBanner";
import ExportLabelDialog from "../../../components/forms/qaReports/exportLabel/ExportLabelDialog";

export function ExportLabelViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });

  const openExportLabelDialog = async function (payload) {
    setEmptyModelOpen({
      open: true,
      childComponent: (
        <ExportLabelDialog
          certImage={
            "https://cool-api-new.ogwebdesign.ca/storage/brand-logos/06/fed.png"
          }
        />
      ),
    });
  };

  const printQaReportById = async function (payload) {
    let callResult = await makePostApiCall(`allergens`, payload);
    setLoading(false);
    if (callResult.success) {
      //   setAllergens(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  return {
    emptyModal,
    loading,
    setEmptyModelOpen,
    setShowSimpleNotification,
    showSimpleNotification,
    openExportLabelDialog,
  };
}
